import React from "react";
import { MOAT } from "./DotCanvas";

// PROTOTYPE (hero shapes): Cerchio's clients as DotCanvas first paints them,
// before any have filled, drawn in the built page's own markup so they show
// with its first paint, while the page's script is still on its way.
// `layout` is the disc in a box 100 across (dotShapes.js), `met` the clients
// you meet. As DotCanvas does with `apart`: the ones still waiting, then a
// moat of the stage round each you meet, then those, each layer one path.
// It fills its box, and is hidden from assistive technology, which reads the
// numbers in the caption.
export default function DotStill({ layout, met }) {
  const waiting = layout.dots.slice(met);
  const resting = layout.dots.slice(0, met);
  return (
    <svg className="hd-still" viewBox="0 0 100 100" aria-hidden="true">
      <path className="hd-still-waiting" d={circles(waiting, layout.size / 2)} />
      <path className="hd-still-moat" d={circles(resting, (layout.size * MOAT) / 2)} />
      <path className="hd-still-met" d={circles(resting, layout.size / 2)} />
    </svg>
  );
}

// A circle of radius `r` round each of `dots`, each drawn as two half arcs.
function circles(dots, r) {
  const radius = hundredths(r);
  const arc = (to) => `a${fixed(radius)} ${fixed(radius)} 0 1 0 ${fixed(to)} 0`;
  return dots.map(({ x, y }) => `M${fixed(hundredths(x) + radius)} ${fixed(hundredths(y))}${arc(-2 * radius)}${arc(2 * radius)}`).join("");
}

// To a hundredth of the box, a twentieth of a pixel on the widest disc.
const hundredths = (n) => Math.round(n * 100);
const fixed = (n) => String(n / 100);
